import { Axios } from '../axios'

const getEmployees = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  const { data } = await Axios.get(
    `/mobile/goals/fetch-employees?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}

export const employees = {
  getEmployees,
}
